export default __webpack_public_path__ + "static/media/modules.43f99839.svg";